export type TBackend = 'development' | 'test' | 'production' | 'local';

declare global {
  interface Window {
    webpackServer: string | null | undefined;
  }
}

export const apiBaseUrls = {
  local: `${window.webpackServer || location.origin}/v1`,
  development: 'https://api.tokenized.com/v1',
  test: 'https://api.tokenized.com/v1',
  production: 'https://api.tokenized.com/v1',
};

export const handleDomains: Record<TBackend, string> = {
  local: 'local.tkz.id',
  development: 'dev.tkz.id',
  test: 'test.tkz.id',
  production: 'tkz.id',
};

export const defaultProtocolIdentifier = 'TKN';
export const protocolIdentifiers: Record<TBackend, string> = {
  local: 'test.TKN',
  development: 'test.TKN',
  test: 'test.TKN',
  production: 'TKN',
};

export const fullHandleTests = {
  anyTokenized: /^[^@]+@.*tkz\.id$/i,
  local: /^[^@]+@local\.tkz\.id$/i,
  development: /^[^@]+@dev\.tkz\.id$/i,
  test: /^[^@]+@test\.tkz\.id$/i,
  production: /^[^@]+@tkz\.id$/i,
};
